const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * El último día de la prueba (`YYYY-MM-DD`): el día de la base de `start_at`, el mismo que dicen
 * el mail de Intercom y Mi plan. Cyclone la cierra al terminar ese día en Argentina, a las 00:00
 * del día siguiente (`trialCutoff` en `src/services/billing/trial-state.ts`, desde el 3/11/2026;
 * antes la cerraba a las 21:00 del día anterior).
 *
 * `start_at` llega de dos formas. Con SQL crudo es un ISO con hora: vale su fecha UTC. Por la
 * entidad de TypeORM (la sesión) es un `YYYY-MM-DD` suelto que cyclone, con `TZ` de Argentina,
 * hidrata un día ANTES (`2026-10-31 00:00+00` llega como `'2026-10-30'`): se le suma un día, como
 * `planDay` en cyclone (`src/services/account-state/stage.ts`).
 */
export const freeTrialLastDay = (startAt: string | Date): number => {
  if (typeof startAt === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(startAt)) {
    const [y, m, d] = startAt.split('-').map(Number);
    return Date.UTC(y, m - 1, d + 1);
  }
  const end = new Date(startAt);
  return Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
};

/**
 * Días de calendario que le quedan a la prueba gratis: 2 (pasado mañana), 1 (mañana), 0 (hoy es
 * el último día) o negativo (ya terminó). "Hoy" es la fecha local del negocio.
 *
 * Antes se contaban horas hasta `start_at + 1 día` redondeando hacia arriba: el número cambiaba
 * a las 21:00 y no a la medianoche, la víspera a la noche decía "en 1 día" y el último día
 * nunca decía "hoy".
 */
export const freeTrialDaysLeft = (startAt: string | Date, now: Date = new Date()): number => {
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((freeTrialLastDay(startAt) - today) / DAY_MS);
};

/** Texto del banner de fin de prueba. */
export const freeTrialEndMessage = (daysLeft: number): string => {
  if (daysLeft <= 0) return 'Tu período de prueba finaliza hoy';
  if (daysLeft === 1) return 'Tu período de prueba finaliza mañana';
  return `Tu período de prueba finaliza en ${daysLeft} días`;
};
